import React, { type FunctionComponent, Fragment } from 'react'

import { type DashRouteComponentProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import { type RetailerScopedRouteParams } from 'legacy/common/types'

import { OrderDetails } from './components/OrderDetails'
import { useOrderDetailsQuery } from './utils/orderDetailsQuery.hooks'

export interface OrderDetailsRouteProps extends DashRouteComponentProps<RetailerScopedRouteParams> {
  order_delivery_id: string
}

const OrderDetailsRoute: FunctionComponent<OrderDetailsRouteProps> = ({
  match: {
    params: { order_delivery_id, partner_id, warehouse_id },
  },
}) => {
  const [orderDetails] = useOrderDetailsQuery({ order_delivery_id, partner_id, warehouse_id })
  return (
    <Fragment>
      {orderDetails ? <OrderDetails data={orderDetails.data} meta={orderDetails.meta} /> : null}
    </Fragment>
  )
}

export default OrderDetailsRoute
